import React from 'react';
import styled from 'styled-components';
import { FaInstagram, FaLinkedin, FaFacebook } from 'react-icons/fa';

const FooterContainer = styled.footer`
  width: 100%;
  background: #0a174e;
  color: #fff;
  padding: 36px 0 24px 0;
  font-size: 1.09rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  text-align: center;
  direction: rtl;
`;

const Brand = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: 1px;
`;

const Socials = styled.div`
  display: flex;
  gap: 18px;
  align-items: center;
`;

const SocialLink = styled.a`
  color: rgba(255,255,255,0.8);
  font-size: 1.5rem;
  transition: color 0.2s, transform 0.2s;
  &:hover { transform: translateY(-2px); }
  &[aria-label='LinkedIn']:hover { color: #0077b5; }
  &[aria-label='Instagram']:hover { color: #e4405f; }
  &[aria-label='Facebook']:hover { color: #1877f2; }
`;

const Copyright = styled.div`
  font-size: 0.9rem;
  opacity: 0.6;
  margin-top: 4px;
`;

const LangRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
`;

const LangBtn = styled.a`
  font-size: 0.85rem;
  font-weight: 700;
  color: rgba(255,255,255,0.55);
  cursor: pointer;
  text-decoration: none;
  transition: color 0.2s;
  &:hover { color: #DA015C; }
  &.active { color: #fff; }
`;

const FooterHe: React.FC = () => {
  const path = typeof window !== 'undefined' ? window.location.pathname : '/he';
  return (
    <FooterContainer>
      <Brand>
        <span style={{ fontWeight: 700, fontSize: 22, letterSpacing: '0.02em' }}>Wassel | וואסל</span>
      </Brand>
      <LangRow>
        <LangBtn href="/" className={path === '/' ? 'active' : ''}>العربية</LangBtn>
        <span style={{ color: 'rgba(255,255,255,0.2)' }}>|</span>
        <LangBtn href="/en" className={path === '/en' ? 'active' : ''}>English</LangBtn>
        <span style={{ color: 'rgba(255,255,255,0.2)' }}>|</span>
        <LangBtn href="/he" className={path === '/he' ? 'active' : ''}>עברית</LangBtn>
      </LangRow>
      <Socials>
        <SocialLink href="https://www.instagram.com/wasseltaxi/" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
          <FaInstagram />
        </SocialLink>
        <SocialLink href="https://www.linkedin.com/company/wassel-mobility/" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
          <FaLinkedin />
        </SocialLink>
        <SocialLink href="https://www.facebook.com/wasseltaxi" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
          <FaFacebook />
        </SocialLink>
      </Socials>
      <Copyright>© 2025 Wassel. כל הזכויות שמורות.</Copyright>
    </FooterContainer>
  );
};

export default FooterHe;
